import { FC } from 'react'
import { Box } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import {
  EntityHeader,
  HasSidebarLayout,
  ManufacturerNewForm,
  ManufacturerNewState,
} from 'src/components'
import { useNewManufacturerRequest } from 'src/hooks/api'
import { useAddPopupMessage } from 'src/hooks/ui'

const NewManufacturer: FC = () => {
  document.title = 'CLīMIT Admin Panel - New manufacturer'
  const navigate = useNavigate()
  const addMessage = useAddPopupMessage()
  const newManufacturerRequest = useNewManufacturerRequest({
    options: {
      onSuccess: () => {
        navigate(-1)
      },
      onError: ({ message: text }) => {
        addMessage({ text, type: 'error' })
      },
    },
  })

  const onSubmit = (submitData: ManufacturerNewState, photo: File | null) => {
    if (photo) {
      newManufacturerRequest.mutate({...submitData, photos: [photo]})
    } else {
      newManufacturerRequest.mutate(submitData)
    }
  }
  return (
    <HasSidebarLayout>
      <EntityHeader title="Create new manufacturer" />
      <Box width="1000px" maxWidth="100%" mt={2}>
        <ManufacturerNewForm onSubmit={onSubmit} isLoading={newManufacturerRequest.isLoading} />
      </Box>
    </HasSidebarLayout>
  )
}

export default NewManufacturer
